<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.groups', 2),
                        href: meta.links.index,
                    },
                    {
                        name: group.name,
                        href: meta.links.group_show,
                    },
                    {
                        name: $tc('messages.grades', 2),
                        href: meta.links.group_grades_show,
                    },
                    {
                        name: category.name,
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.index" method="GET" @submit.prevent="filter">
            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 md:grid-cols-12">
                <div class="sm:col-span-3">
                    <div class="mt-1">
                        <FormLabel :value="$tc('messages.groups', 1)" for="groups" />
                        <FormSelect
                            required
                            id="trimester"
                            v-model="form.group"
                            :options="options.groups"
                            class="mt-1 w-full"
                            :null-option="false"
                        />
                        <FormError :value="form.errors.trimester" class="mt-2" />
                    </div>
                </div>

                <div class="sm:col-span-3">
                    <div class="mt-1">
                        <FormLabel :value="$tc('messages.domains', 1)" for="category" />
                        <FormSelect
                            optgroups
                            required
                            id="category"
                            v-model="form.category"
                            :options="options.categories"
                            class="mt-1 w-full"
                            :null-option="false"
                        />
                        <FormError :value="form.errors.trimester" class="mt-2" />
                    </div>
                </div>

                <div class="sm:col-span-3">
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.trimester')" for="trimester" />
                        <FormSelect
                            required
                            id="trimester"
                            v-model="form.trimester"
                            :options="options.trimesters"
                            class="mt-1 w-full"
                            :null-option="false"
                        />
                        <FormError :value="form.errors.trimester" class="mt-2" />
                    </div>
                </div>

                <div class="sm:col-span-3">
                    <div class="flex justify-end space-x-2">
                        <SubmitFormButton
                            :button-text="$t('messages.filter')"
                            :processing="form.processing"
                            is-filter
                        />
                    </div>
                </div>
            </div>
        </form>

        <div>
            <GradesBarGraphSortable
                :input-series="averageStudentGrade.chartDataOptions.series"
                :input-options="averageStudentGrade.chartDataOptions"
            />

            <div v-if="averageStudentGrade.scoresCount" class="flex space-x-2 flex-wrap">
                <span
                    class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium {{ annotation['bg-color'] }} {{ $annotation['text-color'] }}"
                    :class="[annotation['bg-color'], annotation['text-color']]"
                    v-for="annotation in averageStudentGrade.annotations"
                    :key="annotation.id"
                >
                    {{ annotation.key }}: {{ annotation.value }}
                </span>
            </div>
        </div>

        <div>
            {{ $t('messages.X_students_not_yet_graded', { number: studentsWithoutGrades }) }}
        </div>

        <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-2">
            <div>
                <apexchart
                    type="pie"
                    height="250"
                    :series="pieChartDataOptions.series"
                    :options="pieChartDataOptions"
                />
            </div>
            <div>
                <apexchart type="line" height="250" :series="barChartData.series" :options="barChartData" />
            </div>
        </div>

        <div>
            <div>
                <apexchart
                    type="bar"
                    height="250"
                    :series="perTrimesterBarChartOptions.series"
                    :options="perTrimesterBarChartOptions"
                />
            </div>
        </div>

        <div v-for="graph in otherCharts" :key="graph.key">
            <div>
                <apexchart
                    :type="graph.chart.type"
                    :height="graph.chart.height"
                    :series="graph.series"
                    :options="graph"
                />
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import GradesBarGraphSortable from '@/components/pageSpecific/GradesBarGraphSortable.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import FormError from '@/components/Forms/FormError.vue';

export default {
    components: {
        PanelPage,
        SubmitFormButton,
        GradesBarGraphSortable,
        FormLabel,
        FormSelect,
        FormError,
    },
    layout: Layout,
    name: 'Show',
    props: [
        'averageGradeChartData',
        'meta',
        'group',
        'category',
        'options',
        'filters',
        'averageStudentGrade',
        'pieChartDataOptions',
        'barChartData',
        'perTrimesterBarChartOptions',
        'otherCharts',
        'studentsWithoutGrades',
    ],
    data() {
        return {
            form: this.$inertia.form({
                trimester: this.filters.trimester,
                group: this.filters.group,
                category: this.filters.category,
            }),
        };
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
